import React from "react";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <div>
      {/* <section className="banner-sec w-100 float-left bg-light-black">
        <div className="wrapper2">
          <div className="banner-left-sec">
            <h1
              data-aos="fade-up"
              data-aos-duration={600}
              className="aos-init aos-animate"
            >
              Revolutionizing <span> Decentralized</span> Finance with{" "}
              <span> DNET</span>
            </h1>
            <p
              data-aos="fade-up"
              data-aos-duration={600}
              className="aos-init text-white"
            >
              Join a Next-Gen DeFi Ecosystem Powered by Arbitrum
            </p>
            <div
              className="generic-btn aos-init"
              data-aos="fade-up"
              data-aos-duration={600}
            >
              <a href="#">Get Started</a>
            </div>
          </div>
        </div>
      </section> */}
      <section className="index2-banner-sec">
        {/* Video Background */}
        <video autoPlay loop muted className="video-bg">
          <source src="../assets/images/img/hero_video-1.mp4" type="video/mp4" />
        </video>
        <div className="wrapper2">
          <div className="banner-left-sec">
            <h1 data-aos="fade-up" data-aos-duration={600}>
              Revolutionizing <span>Decentralized</span> Finance with{" "}
              <span>DNET</span>
            </h1>
            <h4 className="text-white">
              AI-Driven | Yield-Optimized | Blockchain-Secured Finance
            </h4>
            <p
              data-aos="fade-up"
              className="text-white"
              data-aos-duration={600}
            >
              Join a Next-Gen DeFi Ecosystem Powered by Arbitrum
            </p>
            <div className="d-flex justify-content-center">
              <Link
                className="button-1 px-5 my-2 my-lg-0"
                to="/login"
                data-aos="fade-up"
                data-aos-duration={600}
              >
                <div className="dots_border" />

                <span className="text_button">Join Now</span>
              </Link>
            </div>

            {/* <div className="generic-btn">
              <a href="#"></a>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Hero;
